import { createContext } from 'react';

/**
 * Visual weight of the device frames inside previews.
 * 'default' is the Post Creator look; 'slim' (Release drawer) trims the bezel
 * and shadows so the platform card is the only raised surface.
 */
export type DeviceFrameDensity = 'default' | 'slim';

export const DeviceFrameDensityContext = createContext<DeviceFrameDensity>('default');

/**
 * Release drawer inline previews: cards fill the column (capped by the wrapper)
 * instead of using their fixed platform max-width. Chrome sizes stay fixed.
 */
export const PreviewFluidContext = createContext(false);
